import {UserOutlined} from "@ant-design/icons";
import {Avatar} from "antd";
import {useGetProfileContext} from "../../../../../../../context/profile/profile-context";

export function ProfileAvatarImage() {
  const {
    state: {
      profileData: {avatar},
    },
  } = useGetProfileContext();

  return (
    <>
      {avatar ? (
        <Avatar size={100} src={avatar} />
      ) : (
        <Avatar size={100} icon={<UserOutlined />} />
      )}
    </>
  );
}
